/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupingRuleCostAnomalyNotification {
    getFixupPrototypeFunction() { return GroupingRuleCostAnomalyNotification.fixupPrototype; }

    static newInstance(model: Partial<GroupingRuleCostAnomalyNotification>): GroupingRuleCostAnomalyNotification {
        let obj = Object.assign(new GroupingRuleCostAnomalyNotification(), model);
        GroupingRuleCostAnomalyNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupingRuleCostAnomalyNotification>): GroupingRuleCostAnomalyNotification {
        if (!model) return null;
        return GroupingRuleCostAnomalyNotification.newInstance(<GroupingRuleCostAnomalyNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupingRuleCostAnomalyNotification) {
        if (!obj) return;

        models.GroupingRuleCostAnomalyNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupingRuleCostAnomalyNotification): boolean {
        Object.setPrototypeOf(obj, GroupingRuleCostAnomalyNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Is Notifications Enabled for Grouping Rule
     */
    notifications_enabled: boolean;

    /**
     * Is Daily Summary Notification Enabled for Grouping Rule
     */
    daily_summary_email_enabled: boolean;

    /**
     * Is Notify On Detection Enabled for Grouping Rule
     */
    notify_on_detection: boolean;

    /**
     * Emails to notify immediately on anomaly detection
     */
    notify_on_detection_emails: Array<string>;

    /**
     * Emails to send daily summary notification
     */
    daily_summary_emails: Array<string>;

    /**
     * Microsoft Teams webhook URLs to notify on anomaly detection
     */
    notify_on_detection_teams_webhooks: Array<string>;

    /**
     * Webhook URLs (Slack or generic) to notify on anomaly detection
     */
    notify_on_detection_webhooks: Array<string>;

    /**
     * Microsoft Teams webhook URLs for daily summary notification
     */
    daily_summary_teams_webhooks: Array<string>;

    /**
     * Webhook URLs (Slack or generic) for daily summary notification
     */
    daily_summary_webhooks: Array<string>;

}
